import { render, staticRenderFns } from "./MyPhotos.vue?vue&type=template&id=7d7857ed&scoped=true&"
import script from "./MyPhotos.vue?vue&type=script&lang=js&"
export * from "./MyPhotos.vue?vue&type=script&lang=js&"
import style0 from "./MyPhotos.vue?vue&type=style&index=0&id=7d7857ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7857ed",
  null
  
)

export default component.exports